export default __webpack_public_path__ + "static/media/Thought Gear Preach.81644016.png";